import { render, staticRenderFns } from "./Textbook.vue?vue&type=template&id=1829693a&scoped=true&"
import script from "./Textbook.vue?vue&type=script&lang=js&"
export * from "./Textbook.vue?vue&type=script&lang=js&"
import style0 from "./Textbook.vue?vue&type=style&index=0&id=1829693a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829693a",
  null
  
)

export default component.exports